// Tiny shared store: how many support replies the signed-in user hasn't read.
// The Header's gear shows a dot while it's > 0; SupportSection clears it after
// marking the replies seen. Module-level so no prop-drilling through
// CoursesPage → Header or SettingsSheet → SettingsContent.
import { useSyncExternalStore } from 'react';
import { getMySupportMessages } from '../../shared/api/support';

let unread = 0;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export function setSupportUnread(n) {
  const next = Math.max(0, Number(n) || 0);
  if (next === unread) return;
  unread = next;
  emit();
}

export function getSupportUnread() { return unread; }

/** Fetch once (best-effort) — called by the Header when it renders a settings gear. */
export async function refreshSupportUnread() {
  try {
    const r = await getMySupportMessages();
    setSupportUnread(r?.unread || 0);
  } catch { /* not signed in / offline — no dot */ }
}

export function useSupportUnread() {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => listeners.delete(l); },
    getSupportUnread,
    () => 0
  );
}

export function __resetSupportUnread() { unread = 0; emit(); }
